var map = {
	"./annex-es/annex1.png": 596,
	"./annex-es/annex2.png": 597,
	"./annex-es/annex3.png": 598,
	"./annex-es/annex4.png": 599,
	"./annex-es/annex5.png": 600,
	"./annex-es/annex6.png": 601,
	"./annex/annex1.png": 602,
	"./annex/annex2.png": 603,
	"./annex/annex3.png": 604,
	"./annex/annex4.png": 605,
	"./annex/annex5.png": 606,
	"./annex/annex6.png": 607,
	"./annex1.png": 282,
	"./annex10.png": 283,
	"./annex11.png": 284,
	"./annex12.png": 285,
	"./annex13.png": 286,
	"./annex14.png": 287,
	"./annex2.png": 288,
	"./annex3.png": 289,
	"./annex4.png": 290,
	"./annex5.png": 291,
	"./annex6.png": 292,
	"./annex7.png": 293,
	"./annex8.png": 294,
	"./annex9.png": 295,
	"./copyright.png": 608,
	"./cover-light.png": 609,
	"./f0021-01.png": 296,
	"./f0021-02.png": 297,
	"./f0022-01.png": 281,
	"./favicon-16x16.png": 610,
	"./favicon-16x16_01.png": 611,
	"./favicon-32x32.png": 612,
	"./favicon-32x32_01.png": 613,
	"./fig25.png": 298,
	"./fig56.png": 299,
	"./fig57.png": 300,
	"./imac-mockup-01.png": 614,
	"./next.png": 615,
	"./poster-sdg-1.png": 278,
	"./poster-sdg-10.png": 301,
	"./poster-sdg-12.png": 302,
	"./poster-sdg-14.png": 303,
	"./poster-sdg-15.png": 304,
	"./poster-sdg-2.png": 279,
	"./poster-sdg-5.png": 305,
	"./poster-sdg-6.png": 306,
	"./prev.png": 616,
	"./reportCover.png": 617,
	"./sdg-12-load.png": 618,
	"./sdg-14-load.png": 619,
	"./sdg-15-load.png": 620,
	"./sdg-2-load.png": 621,
	"./sdg-5-load.png": 622,
	"./sdg-6-load.png": 623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 595;